import React from 'react'

function SearchForm({ setSearchTerm }) {
    const searchValue = React.useRef("");

    React.useEffect(() => {
        // searchValue.current.focus();
    }, []);

    const handleSubmit = (e) =>{
        e.preventDefault();
    }

    const searchMeal = () => {
        setSearchTerm(searchValue.current.value)
    }

    const handleSearchTerm = (e) => {
        setSearchTerm(e.target.value)
        
    };


    return (    
        <section className="h-full w-full flex flex-col items-center justify-center font-mono shadow ">
            <h2 className="text-3xl text-white "> Search for Meals </h2>
            <form onSubmit={handleSubmit} className="h-full w-full  ">
                <div className=" flex flex-col items-center justify-between rounded shadow shadow-lg ">
                    <label className=" text-orange-400 rounded p-1 " htmlFor="name">Search your favorite meal</label>
                    <input className="sm:w-1/2 md:w-2/3 rounded border shadow shadow-xl focus:border-8 focus:outline-none " 
                        type="text" name="name" id="name" 
                    onChange={searchMeal} 
                    ref={searchValue} />
                    
                </div>
            </form>
        </section>
    )
}

export default SearchForm;